import { useState } from "react";
import { useToast } from "@/components/ui/use-toast";
import { useLanguage } from "@/contexts/LanguageContext";
import { useAuth } from "@/contexts/AuthContext";
import { pollutantService } from "@/services/pollutant/pollutantService";

export const usePollutantActions = () => {
    const { toast } = useToast();
    const { t } = useLanguage();
    const { user } = useAuth();
    const [isLoading, setIsLoading] = useState(false);

    const handleDelete = async (id: string) => {
        try {
            setIsLoading(true);
            await pollutantService.delete(id, user?.uid);
            toast({
                title: t("success"),
                description: t("pollutants.deleted"),
            });
        } catch (error) {
            console.error("Error deleting pollutant:", error);
            toast({
                title: t("error"),
                description: t("pollutants.deleteError"),
                variant: "destructive",
            });
        } finally {
            setIsLoading(false);
        }
    };

    return {
        handleDelete,
        isLoading,
    };
}; 